import { FC, lazy } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import { ErrorCode, MultiraceType } from '@/lib/apollo/types/gen/graphql';
import { Velodrome } from '@/modelTypes';
import BasicGuard from '@/routes/middlewares/BasicGuard';

const VelodromeInfoPage = lazy(() => import('@/pages/Velodrome/Info'));
const RaceCardPage = lazy(() => import('@/pages/Velodrome/RaceCard'));
const SingleracePage = lazy(() => import('@/pages/Velodrome/Race/Singlerace'));
const SingleraceResultPage = lazy(
  () => import('@/pages/Velodrome/Result/Singlerace'),
);
const MultiraceSelectPage = lazy(
  () => import('@/pages/Velodrome/Race/Multirace/Select'),
);
const MultiraceRandomPage = lazy(
  () => import('@/pages/Velodrome/Race/Multirace/Random'),
);
const MultiraceResultPage = lazy(
  () => import('@/pages/Velodrome/Result/Multirace'),
);

const ErrorPage = lazy(() => import('@/pages/Error'));

export interface VelodromeRoutesProps {
  velodrome: Velodrome;
}

const VelodromeRoutes: FC<VelodromeRoutesProps> = ({ velodrome }) => {
  return (
    <Switch>
      <Route
        index
        element={
          <BasicGuard>
            <VelodromeInfoPage velodrome={velodrome} />
          </BasicGuard>
        }
      />

      {/* 出走表 */}
      {['racecard', 'racecard/:heldDate'].map(p => (
        <Route
          key={p}
          path={p}
          element={
            <BasicGuard>
              <RaceCardPage velodrome={velodrome} />
            </BasicGuard>
          }
        />
      ))}

      {/* 7賭式 */}
      {['race/result', 'race/:heldDate/result'].map(p => (
        <Route
          key={p}
          path={p}
          element={
            <BasicGuard>
              <SingleraceResultPage velodrome={velodrome} />
            </BasicGuard>
          }
        />
      ))}
      {['race/:raceNum', 'race/:heldDate/:raceNum'].map(p => (
        <Route
          key={p}
          path={p}
          element={
            <BasicGuard>
              <SingleracePage velodrome={velodrome} />
            </BasicGuard>
          }
        />
      ))}

      {/* 重勝 */}
      <Route
        path={'lottery/:heldDate/result'}
        element={
          <BasicGuard>
            <MultiraceResultPage velodrome={velodrome} />
          </BasicGuard>
        }
      />
      {[
        MultiraceType.CharilotoSelect,
        MultiraceType.Chariloto3,
        MultiraceType.Chariloto5,
      ].map(mt => (
        <Route
          key={mt}
          path={`lottery/:heldDate/${mt}`}
          element={
            <BasicGuard>
              <MultiraceSelectPage velodrome={velodrome} multiraceType={mt} />
            </BasicGuard>
          }
        />
      ))}
      {[
        MultiraceType.Chariloto,
        MultiraceType.Dokanto7,
        MultiraceType.Dokanto4two,
      ].map(mt => (
        <Route
          key={mt}
          path={`lottery/:heldDate/${mt}`}
          element={
            <BasicGuard>
              <MultiraceRandomPage velodrome={velodrome} multiraceType={mt} />
            </BasicGuard>
          }
        />
      ))}

      <Route
        path="*"
        element={<ErrorPage forceErrorCode={ErrorCode.NotFound} />}
      />
    </Switch>
  );
};

export default VelodromeRoutes;
